import Entity from "../Common/Entity";
import { PecasTableConfig } from "./Pecas.config";
import Operacoes from './Operacoes/Operacoes';

export default function PecasWrapper() {


    return (<>
        <Entity
            defaultTableConfig={PecasTableConfig}
            useAbsoluteRoute={true}
            blockEdit={true}
         />
        <Operacoes/>
    </>)


}